const StateIcon = () => {
    return (
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="24.000000" height="24.000000" fill="none">
            <rect id="24 / Culture / Pulse" width="24.000000" height="24.000000" x="0.000000" y="0.000000" />
            <path id="Union" d="M9.23874 3L7.36918 13.75L4 13.75L4 15.25L8 15.25L8.63082 15.25L8.73891 14.6285L9.91702 7.85437L11.7428 21L13.2661 21L14.95 12.9175L15.2621 14.6342L15.3741 15.25L16 15.25L20 15.25L20 13.75L16.6259 13.75L15.7623 9L14.2339 9L12.6479 16.6129L10.7572 3L9.23874 3Z" fill="rgb(16,24,40)" fillRule="evenodd" />
        </svg>

    );
};

export default StateIcon;